// src/pages/AuthCallbackPage.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";

export default function AuthCallbackPage() {
  const [error, setError] = useState("");
  const { completeMagicLogin } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setError("Ongeldige of incomplete link.");
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        await completeMagicLogin(token);
        if (!cancelled) {
          // Terug naar de normale Bond-flow
          window.location.href = "/";
        }
      } catch (e) {
        console.error("[AuthCallback] completeMagicLogin error", e);
        if (!cancelled) {
          setError("Deze link is ongeldig of verlopen.");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [completeMagicLogin]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#020617",
        color: "#e5e7eb",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div
        style={{
          padding: "24px 28px",
          borderRadius: 24,
          background: "#020617",
          border: "1px solid rgba(148,163,184,0.35)",
          boxShadow: "0 24px 80px rgba(0,0,0,0.9)",
          maxWidth: 360,
          width: "90%",
          textAlign: "center",
          fontSize: 14,
        }}
      >
        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            marginBottom: 10,
          }}
        >
          BOND
        </div>
        {!error && <div>Bezig met inloggen via je magic link…</div>}
        {error && (
          <div style={{ color: "#fca5a5" }}>
            {error}
            <div style={{ marginTop: 10, fontSize: 12, opacity: 0.9 }}>
              Vraag eventueel een nieuwe login-link aan.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
